import $ from 'jquery';

function ImageSlider(el) {
  var self = this;

  this.$el = $(el);
  this.$content = this.$el.find(this.selectors.content);
  this.$moveEl = this.$el.find(this.selectors.moveEl);
  this.$elements = this.$el.find(this.selectors.elements);
  this.$arrowLeft = this.$el.find(this.selectors.arrowLeft);
  this.$arrowRight = this.$el.find(this.selectors.arrowRight);
  this.totalElWidth = 0;

  this.$elements.each(function(n, element) {
    var $el = $(element);
    var width = $el.outerWidth(true) + 4;

    $el.attr('data-width', width);
    self.totalElWidth += width;
  });

  this.$moveEl.css({ width: self.totalElWidth + 'px' });

  this.updateControls(true);
  this.initEvents();
}

ImageSlider.prototype = {
  contentWidth: 850,
  elementsMargin: 48,
  selectors: {
    slider: '.cms-image-slider',
    content: '.content',
    moveEl: '.move',
    elements: '.move > *',
    arrowLeft: '.arrow.left',
    arrowRight: '.arrow.right'
  },
  $el: null,
  $content: null,
  $moveEl: null,
  $elements: null,
  $arrowLeft: null,
  $arrowRight: null,

  currentElNumber: 0,

  initEvents: function() {
    this.$arrowRight.on('click', $.proxy(this.slideRight, this));
    this.$arrowLeft.on('click', $.proxy(this.slideLeft, this));

    if (this.totalElWidth > this.contentWidth) {
      this.$moveEl.on('touchstart', $.proxy(this.onTouchStart, this));
    }
  },

  onTouchStart: function(event) {
    this.startX = event.originalEvent.touches[0].pageX;
    this.startY = event.originalEvent.touches[0].pageY;

    this.$moveEl.on('touchmove', $.proxy(this.onTouchMove, this));
    this.$moveEl.on('touchend', $.proxy(this.onTouchEnd, this));

    this.currentOffset = this.$moveEl.position().left;
  },

  isEdge: false,

  onTouchMove: function(event) {
    var currentX;
    var currentY;
    var deltaX;
    var deltaY;

    currentX = event.originalEvent.touches[0].pageX;
    deltaX = this.startX - currentX;

    currentY = event.originalEvent.touches[0].pageY;
    deltaY = this.startY - currentY;

    if (Math.abs(deltaX) * 1.2 >= Math.abs(deltaY)) {
      event.preventDefault();
    }

    if (Math.abs(deltaY) > 20 && Math.abs(deltaY) > Math.abs(deltaX) * 2) {
      this.$moveEl.off('touchmove');

      return;
    }

    this.marginLeft = this.currentOffset - deltaX;

    if (this.marginLeft > 0) {
      this.marginLeft = 0;
      this.isEdge = true;
    } else if (this.marginLeft < -this.totalElWidth + this.contentWidth) {
      this.marginLeft = -this.totalElWidth + this.contentWidth;
      this.isEdge = true;
    } else {
      this.isEdge = false;
    }

    this.$moveEl.css('left', this.marginLeft);
  },

  onTouchEnd: function() {
    var $el;
    var width = 0;

    this.$moveEl.off('touchmove');
    this.$moveEl.off('touchend');

    this.startX = null;
    this.startY = null;

    for (let i = 0; i < this.$elements.length; i++) {
      $el = $(this.$elements.get(i));
      width += $el.attr('data-width') - 0;

      if (-width < this.marginLeft) {
        this.currentElNumber = i;
        break;
      }
    }

    this.updateControls(this.isEdge);
    this.currentOffset = null;
  },

  marginLeft: 0,

  slideRight: function() {
    var width = 0;
    var marginLeft = 0;
    var $el;
    var endWithBreak = false;
    var leftElsWidth = 0;

    for (let i = this.currentElNumber; i < this.$elements.length; i++) {
      $el = $(this.$elements.get(i));
      width += $el.attr('data-width') - 0;

      if (width - 48 > this.contentWidth) {
        marginLeft = width - ($el.attr('data-width') - 0);
        this.currentElNumber = i;
        endWithBreak = true;
        break;
      }
    }

    if (!endWithBreak) {
      this.updateControls(true);
    } else {
      for (let i = this.currentElNumber; i < this.$elements.length; i++) {
        $el = $(this.$elements.get(i));
        leftElsWidth += $el.attr('data-width') - 0;
      }

      if (leftElsWidth < this.contentWidth) {
        this.updateControls(true);
      } else {
        this.updateControls(false);
      }
    }

    this.marginLeft -= marginLeft;

    this.$moveEl.css({ left: this.marginLeft + 'px' });
  },

  slideLeft: function() {
    var width = 0;
    var marginLeft = 0;
    var $el;
    var endWithBreak = false;
    var i;

    for (i = this.currentElNumber - 1; i >= 0; i--) {
      $el = $(this.$elements.get(i));
      width += $el.attr('data-width') - 0;

      if (width - 48 > this.contentWidth) {
        endWithBreak = true;
        marginLeft = width - ($el.attr('data-width') - 0);
        break;
      }
    }

    if (!endWithBreak) {
      this.marginLeft = 0;
      this.currentElNumber = 0;
      this.updateControls(true);
    } else {
      this.marginLeft += marginLeft;
      this.currentElNumber = i + 1;
      this.updateControls(false);
    }

    this.$moveEl.css({ left: this.marginLeft + 'px' });
  },

  updateControls: function(isEdge) {
    if (this.totalElWidth < this.contentWidth) {
      this.$arrowLeft.hide();
      this.$arrowRight.hide();
    } else if (isEdge) {
      if (this.currentElNumber === 0) {
        this.$arrowLeft.hide();
        this.$arrowRight.show();
      } else {
        this.$arrowLeft.show();
        this.$arrowRight.hide();
      }
    } else {
      this.$arrowLeft.show();
      this.$arrowRight.show();
    }
  }
};

function init() {
  $('.cms-image-slider').each(function(num, el) {
    new ImageSlider(el);
  });
}

$(function() {
  init();
});



/** WEBPACK FOOTER **
 ** ./legacy/home24/modules/common/cms-image-slider.js
 **/